export const getDepartmentOrganizationDisplay = (departmentName: string, organizationName: string) => {
  // Legacy imports auto-created one same-name department. Treat that exact match as the
  // organization itself so small organizations that may never add departments avoid duplicate names.
  const hideDepartment = departmentName === organizationName;
  return {
    primaryName: hideDepartment ? organizationName : departmentName,
    secondaryName: hideDepartment ? undefined : organizationName
  };
};
